/**
 * Resolve notification click URL for web (Alpine bell / dashboard inbox).
 * Prefers data.web_url; maps uspatihgo:// deep links to dashboard routes.
 */
export function resolveNotificationWebUrl(item) {
  if (!item) return null;
  const data = item.data || {};
  if (data.web_url) {
    const w = String(data.web_url);
    if (w.startsWith('http') || w.startsWith('/')) return w;
  }

  const raw = item.action_url || data.deep_link || data.url || null;
  if (!raw) return null;
  const url = String(raw).trim();
  if (!url) return null;
  if (url.startsWith('/') || url.startsWith('http://') || url.startsWith('https://')) {
    return url;
  }

  const path = url
    .replace(/^uspatihgo:\/\//i, '')
    .replace(/^uspatih:\/\//i, '')
    .replace(/^\//, '')
    .split('?')[0]
    .toLowerCase();

  if (path.startsWith('level') || path.startsWith('xp') || path.startsWith('points') || path === 'poin') {
    return '/dashboard/poin';
  }
  if (path.startsWith('quests') || path.includes('quest')) {
    return '/dashboard/poin';
  }
  if (path.startsWith('orders/')) {
    return `/dashboard/orders/${path.split('/')[1] || ''}`;
  }
  if (path.startsWith('orders')) {
    return '/dashboard/orders';
  }
  if (path.startsWith('wishlist')) {
    return '/dashboard/wishlist';
  }
  if (path.startsWith('notifications')) {
    return '/dashboard/notifications';
  }

  return '/dashboard/notifications';
}
